import React, {Component} from 'react';
import {Form, Control, Errors, Field} from 'react-redux-form';
import _ from 'lodash';
import {isRequired, isRfc, minValue, required} from "../field_validations";
import DatePick from "../forms/datepicker";
import {allUpper, toInt} from "../parsers";
import Loading from "../loading";
import {confirmAlert} from "react-confirm-alert";

export default class ProjectEmployeesEditForm extends Component{
	render(){
		const {projects} = this.props;
		let list = this._getListEmployees(this.state.type_employees);
		let pu = _.find(projects.permissions, (o) => {return o==='Update'});
		return(
			<div className="columns is-centered">
				<div className="column">
					{this.state.employeeEditShow ? <EmployeeEditModal active={this.state.employeeEditShow} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
					<div className="field">
						<div className="control">
							<label htmlFor="type_employees" className="label">Listar personal por:</label>
							<div className="select">
								<select name="type_employees" id="type_employees" ref="type_employees" value={this.state.type_employees} onChange={(e) => this._changeType(e)}>
									<option disabled>-- Tipo de Personal --</option>
									<option value="agency">Instancia</option>
									<option value="project">Proyecto</option>
								</select>
							</div>
						</div>
					</div>

					<table className="inm-table">
						<thead>
						<tr>
							<th>ID</th>
							<th>User ID</th>
							<th>Nombre</th>
							<th>Email</th>
							<th>RFC</th>
							<th>CURP</th>
							<th>Perfil</th>
							<th>Estatus</th>
						</tr>
						</thead>
						<tbody>
						{_.map(list, (row, key) => {
							return [
								<tr key={key}>
									<td rowSpan={this.state.type_employees === 'project' ? 2:1} style={{width: '10%'}}>
										{pu ?
											<div className="actions">
												<button type="button" style={{cursor: 'pointer'}} onClick={() => this._editEmployee(row)}><i className="fa fa-edit" /></button>
												{this.state.type_employees=== 'project' ?
													<button type="button" style={{cursor: 'pointer'}} onClick={() => this._removeEmployee(row.id, `${row.title ? `${row.title} `:''}${row.name} ${row.last_name}${row.slast_name ? ` ${row.slast_name}`:''}`)}><i className="fa fa-trash-o" /></button>:''}
											</div>:''}
										{row.id}
									</td>
									<td style={{width: '10%'}}>{row.user_id}</td>
									<td style={{width: '25%'}}>
										{`${row.title ? `${row.title} `:''}${row.name} ${row.last_name}${row.slast_name ? ` ${row.slast_name}`:''}`}
									</td>
									<td style={{width: '20%'}}>{row.email}</td>
									<td >{row.rfc ? row.rfc:'---'}</td>
									<td >{row.curp ? row.curp:'---'}</td>
									<td style={{width: '20%'}}>{row.role ? row.role.display:'---'}</td>
									<td className={row.status ? `has-text-${row.status.style}`:''}>{row.status ? row.status.name:'---'}</td>

								</tr>,
								this.state.type_employees=== 'project' ?
									<tr key={`goal-${key}`}><td colSpan={7}>
										<strong><span style={{color: '#662d91'}}>META</span></strong><br/>
										{row.project_goal ? `${row.project_goal.code} - ${row.project_goal.name}`:'---'}
									</td></tr>:null
							]
						})}
						</tbody>
					</table>
					<br/>
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button type="button" className="button is-large" onClick={() => this.props.history.push(`/proyectos`)}>Regresar</button>
						</div>
					</div>
				</div>
			</div>
		)
	}

	constructor(){
		super();
		this.state={
			type_employees:'agency',
			employeeEditShow: false
		}
		this._changeType=this._changeType.bind(this);
	}

	_changeType(e){
		this.setState({
			type_employees: e.target.value
		})
	}

	_getListEmployees(type){
		let {projects} = this.props;
		let response = []

		if(!_.isEmpty(projects.employees)){
			if(type && type==='project'){
				response = projects.employees.employees;
			}else if(type && type==='agency'){
				response = projects.employees.agency.employees;
			}
		}

		return response;
	}

	_editEmployee(data){
		let {projects} = this.props;

		if(this.state.type_employees === 'agency'){
			this.props.add('users.list',{
				...data,
				id: data.user_id
			})
		}

		this.props.change(`projects.edit`,{
			...projects.edit,
			type: this.state.type_employees,
			...data
		});

		this.setState({
			employeeEditShow: true
		})
	}

	_removeEmployee(employeeId, name) {
		confirmAlert({
			title: '¿Esta seguro?',
			message: `Al eliminar a ${name}, se eliminará toda la información vinculada.`,
			confirmLabel: 'Eliminar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.projectEmployeeDelete(this.props.match.params.id, employeeId)
		});
	}

	_toggleModal() {
		this.setState({
			employeeEditShow: false
		});

		this.props.reset('projects.edit');
		this.props.reset('users.list');
	}
}

class EmployeeEditModal extends Component{
	render(){
		let {projects, users, status} = this.props;
		let {edit} = projects;
		return(
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content">
					<div className="message">
						<header className="message-header">
							<p>Personal contratado</p>
							<button type="button" onClick={this.props.closeModal} className="delete"
							        aria-label="close"></button>
						</header>
						{edit.isFetching ? <Loading/>:
						<Form model="projects.edit" className="message-body" style={{height: 'inherit'}} onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
							{edit.type === 'agency' ?
							<label htmlFor="search" className="label">Buscar usuarios registrado</label>:''}

							{edit.type === 'agency' ?
							<div className="field has-addons">
								<div className="control">
									<Control.text model=".search" id="search" className="input"/>
								</div>
								<div className="control">
									<button type="button" className="button is-info" onClick={() => this._searchUser()} disabled={edit.search ? false:true}><i className="fa fa-search" /></button>
								</div>
							</div>:''}

							{edit.type === 'agency' ?
								<label htmlFor="user_id" className="label">Usuario <span className="small has-text-danger">*</span></label>:''}

							{edit.type === 'agency' ?
								<div className="field has-addons">
									<div className="control">
										<div className={`select${users.isFetching ? ' is-loading':''}`}>
											<Control.select id="user_id" model=".user_id" parser={ toInt } errors={{required}} validateOn="change"  disabled={users.isFetching || _.isEmpty(users.list)} changeAction={(model,value) => this._changeUser(model,value)}>
												<option value=" " defaultValue>--- Usuario ---</option>
												{_.map(users.list, (opt, k) => {
													return (
														<option key={k} value={opt.id}>{`${opt.title ? `${opt.title} `:''}${opt.name} ${opt.last_name}${opt.slast_name ? ` ${opt.slast_name}`:''}`}</option>
													)
												})}
											</Control.select>
										</div>
										<Errors model=".user_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El usuario es obligatorio'}} />
									</div>
								</div>:''}

							{edit.type === 'project' ?
							<div className="columns is-centered">
								<div className="column">
									<label className="label">Usuario actual</label>
									<p>{`${edit.title ? `${edit.title} `:''}${edit.name} ${edit.last_name}${edit.slast_name ? ` ${edit.slast_name}`:''}`}</p>
								</div>
								<div className="column">
									<label className="label">Perfil</label>
									<p>{edit.role ? edit.role.display:'---'}</p>
								</div>
							</div>:''}

							<div className="field">
								{edit.type === 'project' ?
								<div className="control">
									<label className="label">Meta</label>
									<p>{edit.project_goal ? edit.project_goal.name:'---'}</p>
								</div>
								:<div className="control">
									<label htmlFor="role_id" className="label">Perfil <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select id="role_id" model=".role_id" parser={ toInt } errors={{required}} validateOn="change">
											<option value=" " defaultValue>--- Perfil ---</option>
											{_.map(projects.roles, (opt, k) => {
												return (
													<option key={k} value={opt.id}>{opt.display ? opt.display : opt.name}</option>
												)
											})}
										</Control.select>
									</div>
									<Errors model=".role_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El perfil es obligatorio'}} />
								</div>}
							</div>

							{edit.type === 'project' ?
								<div className="field">
									<div className="control is-expanded">
										<label htmlFor="job_function" className="label">Función <span className="small has-text-danger">*</span></label>
										<Control.text model=".job_function" id="job_function" className="input" placeholder="Función" errors={{isRequired}} validateOn="change"/>
										<Errors model=".job_function" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatorio'}} />
									</div>
								</div>:''}

							{edit.type === 'project' ?
								<div className="field is-grouped">
									<div className="field is-grouped">
										<div className="control">
											<label htmlFor="rfc_invoices" className="label">RFC facturas expedidas </label>
											<Control.text model=".rfc_invoices" id="rfc_invoices" className="input" value={edit.rfc_invoices ? edit.rfc_invoices:''} placeholder="XXXX000000XX0" errors={{ isRfc }} validateOn="change" parser={ allUpper }/>
											<Errors model=".rfc_invoices" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRfc: 'RFC inválido. '}} />
										</div>
									</div>
								</div>:''}

							{edit.type === 'project' ?
								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="wage" className="label">Ingreso mensual <span className="small has-text-danger">*</span></label>
										<div className="control has-icons-left is-expanded">
											<Control.text model=".wage" id="wage" type="number" step=".01" min="0" className="input" placeholder="0,000.00" errors={{isRequired, minValue: minValue(0)}} validateOn="change"/>
											<span className="icon is-small is-left">
												<i className="fa fa-usd"/>
											</span>
										</div>
										<Errors model=".wage" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
									</div>
								</div>:''}

							<label className="label">Periodo de contratación</label>
							<hr style={{margin:'0px'}}/>
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="period_start" className="label">Inicia <span className="small has-text-danger">*</span></label>
									<Control model=".period_start" name="period_start" component={DatePick} className="input" errors={{isRequired}} validateOn="change"/>
									<Errors model=".period_start" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La fecha es obligatorio'}}/>
								</div>

								<div className="control is-expanded">
									<label htmlFor="period_end" className="label">Termina <span className="small has-text-danger">*</span></label>
									<Control model=".period_end" name="period_end" component={DatePick} className="input" errors={{isRequired}} validateOn="change"/>
									<Errors model=".period_end" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La fecha es obligatorio'}}/>
								</div>
							</div>

							<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<Field model=".status_id" className="select" errors={{required}} validateOn="change">
									<select id="status">
										<option defaultValue>--- Estatus ---</option>
										{_.map(status.data, (stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</select>
								</Field>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
								<div className="control">
									<Control.button model="projects.edit" type="submit" className="button is-primary">Guardar</Control.button>
								</div>
							</div>
							<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
						</Form>}
					</div>
				</div>
			</div>
		)
	}

	componentWillReceiveProps(newprops){
		let {edit} = newprops.projects;
		if(edit !== this.props.projects.edit){
			if(edit.action){
				if(edit.action === 'close'){
					this._putInfo(edit);
				}
			}
		}
	}

	_putInfo(data){
		let {projects} = this.props;
		let employeeIndex = undefined;

		if(projects.edit.type==='agency'){
			employeeIndex = _.findIndex(projects.employees.agency.employees, {id: data.id})
			this.props.change(`projects.employees.agency.employees[${employeeIndex}]`,{
				...data,
				action: undefined
			})
		}else {
			employeeIndex = _.findIndex(projects.employees.employees, {id: data.id})
			this.props.change(`projects.employees.employees[${employeeIndex}]`,{
				...data,
				action: undefined
			})
		}

		this.props.closeModal();
	}

	_searchUser(){
		let {projects} = this.props;
		this.props.change('projects.edit.user_id', undefined);
		this.props.change('projects.edit',{
			id: projects.edit.id,
			type: projects.edit.type,
			user_id: undefined,
			role_id: projects.edit.role_id
		});
		this.props.usersFind(projects.edit.search);
	}

	_changeUser(model,value){
		let {projects, users} = this.props;
		let user = _.find(users.list,{id: value});
		this.props.change('projects.edit',{
			...user,
			id: projects.edit.id,
			type: projects.edit.type,
			user_id: value,
			role_id: projects.edit.role_id
		});

	}

	_submitForm(values) {
		//console.log('values====> ',values);
		this.props.projectEmployeeEditSave(this.props.match.params.id,values);
	}
}


// WEBPACK FOOTER //
// ./src/elements/projects/employees.jsx